module.exports = __webpack_public_path__ + "static/media/man.93ef09bc.svg";